import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		wrapper: 'bg-mainPink',
		base: 'flex flex-col lg:flex-row justify-between py-5  lg:py-7 px-2 md:px-4 lg:max-w-[172rem] mx-auto space-y-2 lg:space-y-0 lg:space-x-4',
		grid: '',
	},
})

export type InvestorsVariants = VariantProps<typeof styles>
